import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PaymentV2Service, UtilService } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';

@Component({
  selector: 'app-payment-netbanking',
  templateUrl: './payment-netbanking.component.html',
  styleUrls: ['./payment-netbanking.component.scss']
})
export class PaymentNetbankingComponent implements OnInit {

  @Input() config: IPaymentSipConfig;
  @Output() dataEmit = new EventEmitter();
  selectedBank;
  qprams;
  isMobile;

  constructor(
    private actRoute: ActivatedRoute,
    private paymentV2: PaymentV2Service,
    public util: UtilService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.util?.isMobile();
    this.actRoute.queryParams.subscribe(res => this.qprams = res);
    this.submitForm();
  }


  submitForm() {
    this.paymentV2.pledgeBtn.subscribe(tab => {
      if (tab === 'bank' && this.selectedBank) {
        this.dataEmit.emit({
          mode: this.config.selectedTab.order_mode,
          mode_value: this.selectedBank,
        });
      }
    });
  }

  submit(item) {
    this.selectedBank = item;
    if (this.util.isMobile()) {
      this.dataEmit.emit({
        mode: this.config.selectedTab.order_mode,
        mode_value: this.selectedBank,
      });
    }
  }

}
